
// const initalState

import { IMerchantAccount } from "../interfaces/IMerchantAccount";
import { SET_PERMISSIONS, RESET_PERMISSIONS } from "../yoello-lib/modules/redux/actions/venue.actions";

const initalState: IMerchantAccount | null = null;

export function permissionsReducer(state = initalState, action: any) {
    switch (action.type) {
        case SET_PERMISSIONS:
            state = action.payload;
            return { ...state };
        case RESET_PERMISSIONS:
            state = null;
            return state;
        default:
            return state;
    }
}

